export enum UserRoleEnum {
  Participant = 1,
  Investigator = 2,
  Coordinator = 3,
}
